module.exports = __webpack_public_path__ + "478b3aebb062d29edfea15f0da6d15b2.pdf";